import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import ItemInventory from 'src/components/ItemInventory/ItemList';
import useExposedItems from 'src/components/ItemInventory/useExposedItems';
import ModalLayout, { ModalHeader, ModalLayoutProps, ModalTitle, ModalContent, MobileModalType } from 'src/components/ModalLayout';
import useSelectedTab from 'src/hooks/useSelectedTab';
import { useDuplicateSubscriptionModal } from 'src/hooks/useSubscription';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
const StyledModalLayout = styled(ModalLayout)`
  width: 430px;
  min-width: 430px;
  max-width: 430px;
  border-radius: 24px;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.5);

  ${({
  theme
}) => theme.screenSize.mobile} {
    width: 100%;
    min-width: auto;
    max-width: 100%;
    border-radius: 24px 24px 0 0;
  }
`;
const StyledModalHeader = styled(ModalHeader)`
  padding: 20px 24px 8px;
  min-height: auto;
`;
const StyledModalTitle = styled(ModalTitle)`
  font-size: 22px;
  line-height: 28px;
  color: ${({
  theme
}) => theme.color.content12};

  ${({
  theme
}) => theme.screenSize.mobile} {
    font-size: 20px;
    line-height: 26px;
  }
`;
const StyledModalContent = styled(ModalContent)`
  background-color: ${({
  theme
}) => theme.color.surface2};
  padding: 24px 24px 40px;
  border-radius: 24px;
  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 16px 24px;
    border-radius: 0px;
  }
`;
type Props = ModalLayoutProps;
const ItemInventoryModal = (props: Props) => {
  const {
    t
  } = useTranslation();
  const {
    selectedTab
  } = useSelectedTab();
  const exposedItems = useExposedItems();
  const {
    checkAndShowDuplicateModal
  } = useDuplicateSubscriptionModal();
  useEffect(() => {
    checkAndShowDuplicateModal();
    pushEvent({
      eventType: EVENT_TYPE.INVENTORY,
      eventName: EVENT_NAME.ANYWHERE__IMPRESSION_INVENTORY,
      eventParams: {
        action_category: 'impression',
        tab: selectedTab.name,
        page: 'main',
        target: 'inventory',
        exposed_items: exposedItems
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <StyledModalLayout {...props} mobileType={MobileModalType.BOTTOM_SHEET} data-sentry-element="StyledModalLayout" data-sentry-component="ItemInventoryModal" data-sentry-source-file="Modal.tsx">
      <StyledModalHeader data-sentry-element="StyledModalHeader" data-sentry-source-file="Modal.tsx">
        <StyledModalTitle data-sentry-element="StyledModalTitle" data-sentry-source-file="Modal.tsx">{t('my_items')}</StyledModalTitle>
      </StyledModalHeader>
      <StyledModalContent data-sentry-element="StyledModalContent" data-sentry-source-file="Modal.tsx">
        <ItemInventory data-sentry-element="ItemInventory" data-sentry-source-file="Modal.tsx" />
      </StyledModalContent>
    </StyledModalLayout>;
};
export default ItemInventoryModal;